import { Alert, Strong, Text } from 'braid-design-system';
import { useEffect } from 'react';

import { BasePage } from '../BasePage/BasePage.tsx';

export const ExternalRedirect = ({ to }: { to: string }) => {
  useEffect(() => {
    setTimeout(() => window.location.replace(to), 2000);
  }, [to]);

  return (
    <BasePage title={null} breadcrumbs={null}>
      <Alert tone="info">
        <Text>
          Redirecting to <Strong>{to}</Strong>...
        </Text>
      </Alert>
    </BasePage>
  );
};
